export const HomePageWidgets_queryKey = 'HomePageWidgets';
export const BroadcastTags_queryKey = 'BroadcastTags';
